import React, { useState } from "react";
import Modal from "react-modal";

const DeleteConfirmationModal = ({
  isOpen,
  onRequestClose,
  onConfirm,
  loading,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Confirm Deletion"
      overlayClassName="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center"
      className="w-full max-w-sm mx-auto bg-white rounded-lg p-6 shadow-lg"
    >
      <div className="flex flex-col justify-center items-center">
        <h2 className="mb-4 text-2xl font-bold text-gray-700">
          Confirm Deletion
        </h2>
        <p className="mb-4 text-gray-500 text-center text-base leading-5">
          Are you sure you want to delete this ride? This action cannot be
          undone.
        </p>
        <div className="flex justify-end gap-3 w-full">
          <button
            className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-700"
            onClick={onRequestClose}
          >
            Cancel
          </button>
          <button
            className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
            onClick={onConfirm}
          >
            {loading ? (
              <div className="w-6 h-6 border-4 border-t-white border-red-300 rounded-full animate-spin"></div>
            ) : (
              <p>Yes, Delete</p>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default DeleteConfirmationModal;
